/* eslint-disable */
import { FormRecordFieldView, FormRecordFieldViewFactory } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector } from '@angular/core';
import { FormRecordPhotoFieldComponent } from '../../admin/form/form-record/fields/photo/form-record-photo-field.component';
/* eslint-enable */

export class FormRecordPhotoFieldViewFactory implements FormRecordFieldViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createView(): ComponentRef<FormRecordFieldView> {
    const cmp = this.cfr.resolveComponentFactory(FormRecordPhotoFieldComponent)
      .create(this.injector);
    return cmp;
  }

}
